/**
 * Helpers for time-range filtering & CSV export of leads in the admin area.
 */

export const RANGE_OPTIONS = [
  { key: "7d", label: "7 Tage", days: 7 },
  { key: "30d", label: "30 Tage", days: 30 },
  { key: "90d", label: "90 Tage", days: 90 },
  { key: "6m", label: "6 Monate", days: 30 * 6 },
  { key: "12m", label: "12 Monate", days: 365 },
  { key: "24m", label: "24 Monate", days: 365 * 2 },
  { key: "all", label: "Alle", days: null },
];

export const DEFAULT_RANGE = "30d";

export const filterLeadsByRange = (leads, rangeKey) => {
  const range = RANGE_OPTIONS.find((r) => r.key === rangeKey);
  if (!range || range.days === null) return leads || [];
  const cutoff = Date.now() - range.days * 24 * 60 * 60 * 1000;
  return (leads || []).filter((l) => {
    const t = new Date(l.created_at).getTime();
    return Number.isFinite(t) && t >= cutoff;
  });
};

// CSV-escape a single cell: wrap in quotes if it contains comma, quote, newline.
const escapeCsv = (v) => {
  if (v === null || v === undefined) return "";
  const s = String(v);
  if (/[",\n\r;]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

const CSV_COLUMNS = [
  { key: "created_at", header: "Eingegangen" },
  { key: "name", header: "Name" },
  { key: "email", header: "Email" },
  { key: "phone", header: "Telefon" },
  { key: "service", header: "Quelle / Leistung" },
  { key: "source_domain", header: "Domain" },
  { key: "status", header: "Status" },
  { key: "locale", header: "Sprache" },
  { key: "message", header: "Nachricht" },
];

export const leadsToCsv = (leads) => {
  const header = CSV_COLUMNS.map((c) => c.header).join(",");
  const rows = (leads || []).map((l) =>
    CSV_COLUMNS.map((c) => {
      if (c.key === "created_at" && l.created_at) {
        try {
          return escapeCsv(new Date(l.created_at).toISOString());
        } catch {
          return escapeCsv(l.created_at);
        }
      }
      return escapeCsv(l[c.key] ?? "");
    }).join(","),
  );
  // BOM for Excel UTF-8 compatibility
  return "\uFEFF" + [header, ...rows].join("\r\n");
};

export const downloadCsv = (filename, csvString) => {
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
